<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Find address</ion-title>
  </ion-toolbar>

  @if (google_maps_connected) {
    <ion-toolbar>
      <ion-searchbar #search_bar_input placeholder="Start typing an address" debounce="300" [(ngModel)]="search_query" (ionInput)="searchAddresses()" show-clear-button="never"></ion-searchbar>
    </ion-toolbar>
  }

</ion-header>

<ion-content>

  @if (!google_maps_connected) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'exchange']" size="6x"></fa-icon>
            <span>Google Maps not connected</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

  @if (google_maps_connected && suggestions && suggestions.length != 0) {
    <ion-list>
      @for (suggestion of suggestions; track suggestion) {
        <ion-item lines="full" button="true" (click)="retrieveAddress(suggestion)">
          <ion-label>
            <p>{{suggestion.placePrediction.text.text}}</p>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  @if (google_maps_connected && suggestions && suggestions.length == 0 && search_query && search_query.length >= 3) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'map-marker-alt']" size="6x"></fa-icon>
            <span>No addresses found</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>
